import React, { useEffect, useRef, useState } from 'react';
import Pesquisar from '../Pesquisar';
import { Card, Spin } from 'antd';
import '../TelaVendas.css'; // Assumindo que os estilos foram movidos para um arquivo CSS
import ModalItemSelecionado from '../ModalItemSelecionado';
import FinalizarOrcamento from './FinalizarOrcamento';
import LeitorQRCode from '../LeitorQRCode';
import BuscarOrcamentos from './BuscarOrcamentos';
import axios from 'axios';

const Orcamentos = () => {


  const [isBuscarOrcamento, setIsBuscarOrcamento] = useState(false);
  const [isPesquisar, setIsPesquisar] = useState(false);
  const [isFinalizarOrcamento, setIsFinalizarOrcamento] = useState(false);

  const [acresDescFreteConcluido, setAcresDescFreteConcluido] = useState(false);
  const [pagamentoConcluido, setPagamentoConcluido] = useState(false);
  const [pagamentos, setPagamentos] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [quantidadeDeItens, setQuantidadeDeItens] = useState(0);
  const [precoTotal, setPrecoTotal] = useState(0);
  const [totalSemFrete, setTotalSemFrete] = useState(0);
  const [totalDescontos, setTotalDescontos] = useState(0);
  const [totalAcrescimos, setTotalAcrescimos] = useState(0);
  const [subTotal, setSubtotal] = useState(0);
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const operador = window.localStorage.getItem("operador");
  const [isLoading, setIsLoading] = useState(false);
  const [nomeCupom, setNomeCupom] = useState('');
  const [documentoCupom, setDocumentoCupom] = useState('');
  const [numeroEvento, setnumeroEvento] = useState('');
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [isModalVisibleItem, setModalVisibleItem] = useState(false);
  const [isLerCodigo, setIsLerCodigo] = useState(false);
  const [idOrcamento, setIdOrcamento] = useState('');
  const [cardAberto, setCardAberto] = useState('');
  const [consumidorIdentificado, setConsumidorIdentificado] = useState(false);
  const [consumidor, setConsumidor] = useState(null);
  const [formasDePagamento, setFormasDePagamento] = useState([]);
  const [restauranteId, setRestauranteId] = useState('');
  const inputRef = useRef(null);
  const [mensagem, setMensagem] = useState('');
  const [idVendedorOrcamento, setIdVendedorOrcamento] = useState(null);


  const [acresDescFrete, setAcresDescFrete] = useState({
    acresTotal: '0',
    descTotal: '0',
    frete: '0',
  });
  const [pagItem, setPagItem] = useState([]);

  const tratarProdutoBuscadoPorEan = item => {
    item.quantidade = 1;
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;
    trataProdutos(item);
    setPagamentoConcluido(false);
    setPagamentos([]);
  };

  const tratarProdutoBuscadoPorCodigoDeBalanca = item => {
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;
    trataProdutos(item);
    setPagamentoConcluido(false);
    setPagamentos([]);
  };


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const valor = e.target.value.trim();
      if (valor) {
        buscarProdutoPorCodigoBarras(valor);
        e.target.value = ''; // limpa o campo
        inputRef.current.focus(); // volta o foco
      }
    }
  };

  const toNumber = (v) => {
    if (v == null) return NaN;
    const s = String(v).trim().replace(',', '.').replace(/[^\d.]/g, '');
    return Number(s);
  };

  const extrairCodigoParaBusca = (codigoBarras) => {
    const cb = String(codigoBarras || '').trim();

    if (cb.includes('$')) {
      const [, codigo] = cb.split('$');   // pega depois do $
      return String(codigo || '').trim();
    }

    if (cb.includes('*')) {
      const [, codigo] = cb.split('*');   // pega depois do *
      return String(codigo || '').trim();
    }

    return cb;
  };

  const tratarProdutoQuantidadeValor = (item, codigoBarras) => {
    const cb = String(codigoBarras || '').trim();

    // defaults
    item.quantidade = 1;
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;

    // "*" => 40*12  => quantidade=40, preco = preco*40
    if (cb.includes('*')) {
      const [qStr] = cb.split('*');
      const q = toNumber(qStr);

      if (Number.isFinite(q) && q > 0) {
        item.quantidade = q;
      }

      // "$" => 40$12  => 40 é valor total, 12 é só o código; qtd = total / precoUnit
    } else if (cb.includes('$')) {
      const [totalStr] = cb.split('$'); // ignora o "12" (código)
      const total = toNumber(totalStr);

      const precoUnit = toNumber(item.preco); // preço unitário do produto já buscado
      if (Number.isFinite(total) && total > 0 && Number.isFinite(precoUnit) && precoUnit > 0) {
        item.quantidade = total / precoUnit;

        // se quiser limitar casas (ex.: 3) para não ficar infinito:
        // item.quantidade = Number((total / precoUnit).toFixed(3));
      }
    }

    trataProdutos(item);
    setPagamentoConcluido(false);
    setPagamentos([]);
  };

  const buscarProdutoPorCodigoBarras = async (codigoBarras) => {
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };

      let response = {};
      let codigoDeBalanca = false;
      if (codigoBarras !== '') {
        if (codigoBarras.startsWith("2")) {
          console.log("O código de barras começa com 2");
          codigoDeBalanca = true;

        }

        const codigoParaBusca = extrairCodigoParaBusca(codigoBarras);

        setMensagem(`🔍 Procurando o código de barras: ${codigoBarras}`);
        response = await axios.get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${restauranteId}/produtos/buscarporean/${codigoParaBusca}`,
          options
        );

        console.log(response.data);
        if (response.data && response.status == 200) {
          if (codigoDeBalanca) {
            console.log(response.data.quantidade);
            console.log(response.data.valorAferido);
            console.log(response.data.preco);

            const { valorAferido, preco } = response.data;

            if (
              typeof valorAferido === 'number' &&
              typeof preco === 'number' &&
              preco !== 0
            ) {
              response.data.quantidade = (valorAferido / preco).toFixed(3);
            } else {
              response.data.quantidade = "0.000";
            }


            tratarProdutoBuscadoPorCodigoDeBalanca(response.data);

          } else {
            if (codigoBarras.includes('*') || codigoBarras.includes('$')) {
              tratarProdutoQuantidadeValor(response.data, codigoBarras);
            } else {
              tratarProdutoBuscadoPorEan(response.data);
            }
          }
          setMensagem(``);
        } else {

          response = await axios.get(
            `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${restauranteId}/produtos/buscarporcod/${codigoParaBusca}`,
            options
          );

          if (response.data && response.status == 200) {
            if (codigoBarras.includes('*') || codigoBarras.includes('$')) {
              tratarProdutoQuantidadeValor(response.data, codigoBarras);
            } else {
              tratarProdutoBuscadoPorEan(response.data);
            }
            setMensagem(``);
          }

          if (response.status != 200) {
            setMensagem(`❌ Código de barras não encontrado: ${codigoBarras}`);
          }


        }

      }
    } catch (error) {
      console.error('Erro ao buscar produto por EAN:', error);
      if (error.status == 404) {
        setMensagem(`❌ Código de barras não encontrado: ${codigoBarras}`);
      }

    }

  };


  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };
      axios
        .get(`https://techfood-api.herokuapp.com/v1/restaurantes/usuario/${idUser}`, options)
        .then(response => {
          setRestauranteId(response.data.id);
        })
        .catch(error => console.error('Erro ao buscar restaurante:', error));
    }
  }, [idUser, accessToken]);

  useEffect(() => {
    if (restauranteId) {
      axios
        .get(
          `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${restauranteId}/formas-pagamento`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        )
        .then((response) => {
          const options = response.data._embedded.formasPagamento.map((forma) => ({
            label: forma.descricao,
            value: forma.codigo,
          }));
          setFormasDePagamento(options);
        });
    }
  }, [restauranteId]);


  const [recalcular, setRecalcular] = useState(false);


  const handlePesquisarClick = () => {
    setIsPesquisar(true); // Mostrar a tela de pesquisa
  };

  const handleVoltarClick = () => {
    setIsPesquisar(false); // Voltar para a tela de vendas
  };

  const trataProdutos = produto => {
    setProdutos([...produtos, produto]);

  };


  const getDataAtual = () => {
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const ano = dataAtual.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  const CalcularTotais = () => {
    var quantidadeDeItensAux = 0;
    var precoTotalAux = 0;
    var totalSemFreteAux = 0;
    var subTotalAux = 0;
    var totalDescontosAux = 0;
    var totalAcrescimosAux = 0;

    produtos.map(produto => {
      console.log(produto);
      quantidadeDeItensAux = quantidadeDeItensAux + produto.quantidade;

      subTotalAux = subTotalAux + produto.preco * produto.quantidade;
      totalSemFreteAux =
        totalSemFreteAux +
        produto.preco * produto.quantidade -
        parseFloat(produto.valorDesconto) +
        parseFloat(produto.valorAcrescimo);

      precoTotalAux =
        precoTotalAux +
        produto.preco * produto.quantidade -
        parseFloat(produto.valorDesconto) +
        parseFloat(produto.valorAcrescimo) +
        parseFloat(produto.frete ? produto.frete : 0);

      console.log('precoTotalAux');
      console.log('precoTotalAux');
      console.log('precoTotalAux');
      console.log(precoTotalAux);

      totalDescontosAux += parseFloat(produto.valorDesconto);
      totalAcrescimosAux += parseFloat(produto.valorAcrescimo);
    });
    setQuantidadeDeItens(quantidadeDeItensAux);
    setPrecoTotal(precoTotalAux);
    setTotalSemFrete(totalSemFreteAux);
    setSubtotal(subTotalAux);
    setTotalDescontos(totalDescontosAux);
    setTotalAcrescimos(totalAcrescimosAux);
  };

  const openModalItem = produto => {
    setSelectedProduto(produto);
    setModalVisibleItem(!isModalVisibleItem);
  };
  useEffect(() => {
    CalcularTotais();
  }, [produtos, recalcular]);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', backgroundColor: '#f9f9f9' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '5px', marginTop: 0 }}>Orçamentos</h1>


      {
        isBuscarOrcamento ? (
          <BuscarOrcamentos
            closeModal={() => {
              setIsBuscarOrcamento(false);
            }}
            tratarProdutosOrcamento={orcamento => {
              setIsLoading(true);
              setIdVendedorOrcamento(orcamento.idVendedor);
              function validarDocumento(documento) {
                // Remover caracteres não numéricos
                documento = documento.replace(/[^\d]+/g, '');

                // Verificar se o documento é um CPF
                if (documento.length === 11) {
                  let cpf = documento;
                  let add = 0;
                  for (let i = 0; i < 9; i++) {
                    add += parseInt(cpf.charAt(i)) * (10 - i);
                  }
                  let rev = 11 - (add % 11);
                  if (rev === 10 || rev === 11) rev = 0;
                  if (rev !== parseInt(cpf.charAt(9))) return false;

                  add = 0;
                  for (let i = 0; i < 10; i++) {
                    add += parseInt(cpf.charAt(i)) * (11 - i);
                  }
                  rev = 11 - (add % 11);
                  if (rev === 10 || rev === 11) rev = 0;
                  if (rev !== parseInt(cpf.charAt(10))) return false;

                  return true;
                }

                // Verificar se o documento é um CNPJ
                else if (documento.length === 14) {
                  let cnpj = documento;
                  let tamanho = cnpj.length - 2;
                  let numeros = cnpj.substring(0, tamanho);
                  let digitos = cnpj.substring(tamanho);
                  let soma = 0;
                  let pos = tamanho - 7;
                  for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2) pos = 9;
                  }
                  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                  if (resultado !== parseInt(digitos.charAt(0))) return false;

                  tamanho = tamanho + 1;
                  numeros = cnpj.substring(0, tamanho);
                  soma = 0;
                  pos = tamanho - 7;
                  for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2) pos = 9;
                  }
                  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                  if (resultado !== parseInt(digitos.charAt(1))) return false;

                  return true;
                }

                // Se não for nem CPF nem CNPJ, retorna false
                else {
                  return false;
                }
              }
              if (validarDocumento(orcamento.cpf)) {
                console.log('Cpf valido');
                if (accessToken) {
                  const options = {
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + accessToken,
                    },
                  };

                  axios
                    .get(
                      `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${orcamento.idEmpresa}/cpfcnpj/${orcamento.cpf}`,
                      options,
                    )
                    .then(consumidorResp => {
                      console.log(
                        `https://techspdv-api-d3e739785e34.herokuapp.com/v1/clientes/loja/${orcamento.idEmpresa}/cpfcnpj/${orcamento.cpf}`,
                      );

                      if (consumidorResp) {
                        console.log(consumidorResp.data);
                        if (consumidorResp.data) {
                          setConsumidor(consumidorResp.data);
                          setConsumidorIdentificado(true);
                        }
                      }
                    })
                }
              }

              const pagamentosAux = [];
              orcamento.pagamentos.map(pagamento => {

                const novoPagamento = {
                  tipo: pagamento.codigoFiscal,
                  tipoNome: pagamento.descricao,
                  valor: pagamento.valor,
                }
                pagamentosAux.push(novoPagamento);

              })
              console.log('Pagamentos');
              console.log(pagamentosAux);
              setPagamentos(pagamentosAux);



              let pagItemAux = new Array();
              pagamentosAux.map(pagamento => {
                const pagamentoFormatado = {
                  tPag: pagamento.tipo,
                  vPag: pagamento.valor.toFixed(2),
                  xPag: pagamento.tipoNome,
                };
                pagItemAux.push(pagamentoFormatado);
              });
              setPagItem(pagItemAux);

              setPagamentoConcluido(true);
              console.log('orcamento');
              console.log(JSON.parse(orcamento.jsonDocFiscal).det.detItem);

              // pegue e normalize o detItem
              const detItems = JSON.parse(orcamento.jsonDocFiscal)?.det?.detItem;
              const detArray = Array.isArray(detItems) ? detItems : (detItems ? [detItems] : []);

              // índice por cProd (chave como string para evitar problemas de tipo)
              const detByCProd = new Map(
                detArray.map(it => [String(it?.prod?.cProd), it])
              );

              detArray.map(async item => {
                console.log(item);

                const produto = item?.prod;
                try {
                  const options = {
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + accessToken,
                    },
                  };

                  const response = await axios.get(
                    `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${orcamento.idEmpresa
                    }/produtos/${produto.cProd}?page=${0}`,
                    options,
                  );

                  const produtosAux = produtos;
                  if (response.data) {
                    console.log(response.data);

                    response.data.preco = produto.vUnCom;
                    response.data.quantidade = produto.qCOM;
                    response.data.acrescimo = produto.vOutro_item;
                    response.data.desconto = produto.vDesc;
                    response.data.valorAcrescimo = produto.vOutro_item;
                    response.data.valorDesconto = produto.vDesc;
                    response.data.frete = produto.vFrete ? produto.vFrete : 0;
                    response.data.observacao = produto.observacao || '';
                    response.data.idVendedor = produto.idVendedor || '';
                    console.log(response.data);
                    produtosAux.push(response.data);
                    CalcularTotais();
                  }

                  setProdutos(produtosAux);
                } catch (error) {
                  setIsLoading(false);
                  console.error('Erro ao fazer a requisição:', error);
                }
              })



              /* orcamento.itens.map(async prod => {
                 try {
                   const options = {
                     headers: {
                       Accept: 'application/json',
                       'Content-Type': 'application/json',
                       Authorization: 'Bearer ' + accessToken,
                     },
                   };
                   console.log(
                     `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${orcamento.idEmpresa
                     }/produtos/${prod.idReferencialProduto}?page=${0}`,
                   );
                   const response = await axios.get(
                     `https://techspdv-api-d3e739785e34.herokuapp.com/v1/restaurantes/${orcamento.idEmpresa
                     }/produtos/${prod.idReferencialProduto}?page=${0}`,
                     options,
                   );
   
                   const produtosAux = produtos;
                   if (response.data) {
                     console.log(response.data);
                     console.log(prod);
                     response.data.preco = prod.valorUnitario;
                     response.data.quantidade = prod.quantidade;
                     response.data.acrescimo = prod.valorTotalAcrescimo;
                     response.data.desconto = prod.valorTotalDesconto;
                     response.data.valorAcrescimo = prod.valorTotalAcrescimo;
                     response.data.valorDesconto = prod.valorTotalDesconto;
                     response.data.frete = prod.vfrete ? prod.vfrete : 0;
                     response.data.observacao = detByCProd.get(prod.idReferencialProduto).prod.observacao;
                     console.log(response.data);
                     produtosAux.push(response.data);
                     CalcularTotais();
                   }
   
                   setProdutos(produtosAux);
                 } catch (error) {
                   setIsLoading(false);
                   console.error('Erro ao fazer a requisição:', error);
                 }
               });*/
              setIdOrcamento(orcamento.id);

              let acresDescFreteAux = acresDescFrete;
              acresDescFreteAux.frete = orcamento.valorFrete;
              setAcresDescFrete(acresDescFreteAux);
              console.log('orcamento');
              console.log('orcamento');
              console.log(orcamento);
              console.log('produtos');
              console.log(produtos);


              setIsLoading(false);

            }}
          />

        ) :
          isPesquisar ? (
            <Pesquisar
              onItemPress={trataProdutos}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagamentos={setPagamentos}
              closeModal={handleVoltarClick}
              validarEstoque={false}
            ></Pesquisar>
          ) : isLerCodigo ? (
            /*  <Leitor
                closeModal={() => {
                setIsLerCodigo(false);
              }}
              onItemPress={trataProdutos}
              setPagamentoConcluido={setPagamentoConcluido}
              setPagamentos={setPagamentos}>
              </Leitor>*/
            <LeitorQRCode />
          ) :
            isFinalizarOrcamento ? (<FinalizarOrcamento
              closeModal={() => { setIsFinalizarOrcamento(false) }}
              onItemPress={trataProdutos}
              setConsumidorIdentificado={setConsumidorIdentificado}
              consumidorIdentificado={consumidorIdentificado}
              nomeCupom={nomeCupom}
              documentoCupom={documentoCupom}
              setNomeCupom={setNomeCupom}
              setDocumentoCupom={setDocumentoCupom}
              consumidor={consumidor}
              setConsumidor={setConsumidor}
              precoTotal={precoTotal}
              pagamentoConcluido={pagamentoConcluido}
              setPagamentoConcluido={setPagamentoConcluido}
              pagamentos={pagamentos}
              setPagamentos={setPagamentos}
              produtos={produtos}
              setProdutos={setProdutos}
              subTotal={subTotal}
              CalcularTotais={CalcularTotais}
              acresDescFrete={acresDescFrete}
              setAcresDescFrete={setAcresDescFrete}
              totalDescontos={totalDescontos}
              totalAcrescimos={totalAcrescimos}
              acresDescFreteConcluido={acresDescFreteConcluido}
              setAcresDescFreteConcluido={setAcresDescFreteConcluido}
              setPagItem={setPagItem}
              pagItem={pagItem}
              formasDePagamento={formasDePagamento}
              idVendedorOrcamento={idVendedorOrcamento}
              idOrcamento={idOrcamento}

            ></FinalizarOrcamento>) : (
              isModalVisibleItem ? (
                <ModalItemSelecionado
                  isVisible={isModalVisibleItem}
                  onClose={() => setModalVisibleItem(false)}
                  onSave={updatedProduto => {
                    console.log(updatedProduto);
                    produtos[updatedProduto.index] = updatedProduto;
                    //produto = updatedProduto;
                    setRecalcular(!recalcular);
                    setPagamentoConcluido(false);
                    setPagamentos([]);
                  }}
                  onDelete={item => {
                    produtos.splice(item.index, 1);
                    setRecalcular(!recalcular);
                    setPagamentoConcluido(false);
                    setPagamentos([]);
                  }}
                  produto={selectedProduto}
                />
              ) : (
                // Caso contrário, exibe a tela de vendas
                <div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                    {/* <button
              style={{
                flex: 1,
                marginRight: '10px',
                backgroundColor: '#800080',
                color: '#fff',
                padding: '15px',
                borderRadius: '5px',
                border: 'none',
                fontSize: '16px',
              }}
              onClick={()=>{setIsLerCodigo(true)}} 
            >
              <span style={{ display: 'block', fontSize: '24px' }}>📷</span>
              Ler Código
            </button>*/}
                    <button
                      onClick={handlePesquisarClick}
                      style={{
                        flex: 1,
                        marginRight: '10px',
                        backgroundColor: '#000',
                        color: '#fff',
                        padding: '15px',
                        borderRadius: '5px',
                        border: 'none',
                        fontSize: '16px',
                      }}
                    >
                      <span style={{ display: 'block', fontSize: '24px' }}>🔍</span>
                      Pesquisar
                    </button>
                    <button
                      style={{
                        flex: 1,
                        backgroundColor: '#90ee90',
                        color: '#000',
                        padding: '15px',
                        borderRadius: '5px',
                        border: 'none',
                        fontSize: '16px',
                      }}

                      onClick={() => { produtos.length > 0 ? setIsFinalizarOrcamento(true) : window.alert('Adicione produtos a compra!') }}
                    >
                      <span style={{ display: 'block', fontSize: '24px' }}>✔️</span>
                      Finalizar Venda
                    </button>
                  </div>
                  <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <button
                      style={{
                        backgroundColor: '#000',
                        color: '#fff',
                        padding: '15px',
                        borderRadius: '5px',
                        border: 'none',
                        fontSize: '16px',
                        width: '100%',
                      }}
                      onClick={() => {
                        setIsBuscarOrcamento(true);
                      }}
                    >
                      <span style={{ display: 'block', fontSize: '24px' }}>📄</span>
                      Buscar Orçamento
                    </button>
                  </div>
                  <div style={{ backgroundColor: '#d3d3d3', padding: '15px', borderRadius: '5px' }}>
                    <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '14px' }}>{getDataAtual()}</p>
                    <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '14px' }}>{`Operador: ${operador}`}</p>
                    <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '14px' }}>Total da Venda: {totalSemFrete.toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}</p>
                    <p style={{ margin: '5px 0', fontWeight: 'bold', fontSize: '14px' }}> {`Total de Itens na Venda: ${quantidadeDeItens}`}</p>



                    {/* Input centralizado com foco automático */}
                    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
                      <input
                        ref={inputRef}
                        type="text"
                        placeholder="Digite o código de barras"
                        onKeyDown={handleKeyDown}
                        style={{
                          width: '250px',
                          padding: '8px',
                          borderRadius: '4px',
                          border: '1px solid #ccc',
                          fontSize: '14px',
                          textAlign: 'center',
                        }}
                      />
                    </div>

                    {/* Exibição da "resposta" do endpoint simulado */}
                    {mensagem && (
                      <div style={{ marginTop: '10px', textAlign: 'center', color: '#333', fontWeight: 'bold' }}>
                        {mensagem}
                      </div>
                    )}

                  </div>


                  {[...produtos].reverse().map((produto, index) => {
                    const originalIndex = produtos.length - 1 - index;
                    return (
                      <>
                        {isLoading ? (
                          <Spin />
                        ) : (

                          <div
                            className={`cardT ${produto.travado ? 'travado' : ''}`}
                            onClick={() => {
                              if (!produto.travado) openModalItem({ ...produto, index: originalIndex });
                            }}
                            style={{ display: "flex", width: "100%" }}
                          >
                            {/* ESQUERDA - 60% */}
                            <div style={{ width: "60%" }}>
                              <span className="cardTextNome">{produto.nome}</span><br />
                              <span className="cardText">{`${produto.ean}`}</span><br />
                              <span className="cardText">
                                {`${Number(produto.quantidade || 0).toLocaleString('pt-BR', {
                                  minimumFractionDigits: 3,
                                  maximumFractionDigits: 3,
                                })
                                  } ${produto.unidade || 'UN'} X ${produto.preco.toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )} = ${(produto.quantidade * produto.preco).toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )} - ${parseFloat(produto.valorDesconto).toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )} + ${parseFloat(produto.valorAcrescimo).toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    },
                                  )} = ${(
                                    parseFloat(produto.quantidade) *
                                    parseFloat(produto.preco) -
                                    parseFloat(produto.valorDesconto) +
                                    parseFloat(produto.valorAcrescimo)
                                  ).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                  })}`}
                              </span>
                            </div>

                            {/* DIREITA - 40% */}
                            <div style={{ width: "40%", paddingLeft: "10px", borderLeft: "1px solid #ddd" }}>
                              <span className="cardText">
                                {produto.observacao || <i style={{ color: "#aaa" }}>Sem observação</i>}
                              </span>
                            </div>
                          </div>



                        )}


                      </>
                    );
                  })}
                </div>
              )
            )}
    </div >
  );
};

export default Orcamentos;
